<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <!-- BEGINN DER LOHNZAHLUNGEN -->
  <div class="mb-5x">
    <h3>
      {{ 'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.BEGINN_LOHNZAHLUNGEN.TITEL' | translate }}
    </h3>

    <div class="form-row">
      <label class="col-sm-8 col-form-label" for="beginnLohnzahlungen">
        {{ 'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.BEGINN_LOHNZAHLUNGEN.BEGINN_LOHNZAHLUNGEN' | translate }}
      </label>
      <div class="col-sm-4">
        <date-picker
                id="beginnLohnzahlungen"
                messagePath="beginnLohnzahlungen"
                formControlName="beginnLohnzahlungen"
                [isRequired]=true>
        </date-picker>
      </div>
    </div>
  </div>

</form>


